import { render, staticRenderFns } from "./UserDetailsPassword.vue?vue&type=template&id=36cf67b8&"
import script from "./UserDetailsPassword.vue?vue&type=script&lang=js&"
export * from "./UserDetailsPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports